module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/modules/_library.js
// module id = 41
// module chunks = 169